import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';

import { useVehicleRecommendationsLink } from '../../baseDealActivity/baseDealContainer/hooks/useVehicleRecommendationsLink';
import { InsightLink } from './ScenarioAiInsights.style';

export const VEHICLE_RECOMMENDATIONS_LABEL = 'Alternative Vehicle Options';

export const ScenarioVehicleRecommendationsLink = ({ scopeId, isDisabled }: { scopeId: string; isDisabled: boolean }) => {
    const theme = useInterstateTheme();
    const openRecommendations = useVehicleRecommendationsLink(scopeId);

    return (
        <InsightLink
            type="button"
            theme={theme}
            onClick={openRecommendations}
            disabled={isDisabled}
            data-testid="ai-card-vehicle-recommendations-label"
        >
            {VEHICLE_RECOMMENDATIONS_LABEL}
        </InsightLink>
    );
};
